var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect } from 'react';
import { inject } from 'mobx-react';
import { observer } from "mobx-react-lite";
import { ProblemBusiness } from '@business/newCreateRequest/stepsItems/problem';
import { Loader } from 'oned';
import LevelOne from './levelOne';
import LevelTwo from './levelTwo';
import LevelThree from './levelThree';
import { AmplitudeEventName, MobileDefinedClientType, PredefinedWoType, ProblemLevel, StepType } from '@common/enums/base';
import './index.less';
import { getCurrentEnv, getLocationId, isIH, isMobile, sendAmplitude_Default } from '@common/utils';
import ProblemAlias from './problemAlias';
import ICantFindMyIssue from './iCantFindMyissue';
import DuplicateCheckList from './duplicateCheck';
import { isEmpty } from 'lodash-es';
import ResidentResponsibility from './residentResponsibility';
import Cookies from 'js-cookie';
import RecallCheckList from './recallCheck';
import HowToVideo from './howToVideo';
import HowToVideoMobile from './howToVideo/mobile';
var DifferentIssue = ProblemLevel.DifferentIssue;
var StepsProblem = inject(ProblemBusiness)(observer(function (props) {
    var level = props.level, getClientServiceComboAlias = props.getClientServiceComboAlias, clientId = props.clientId, loading = props.loading, levelOneAliasList = props.levelOneAliasList, currentUser = props.currentUser, reGetClientId = props.reGetClientId, duplicateWOsLoading = props.duplicateWOsLoading, setProblemLevel = props.setProblemLevel, getDuplicateWOList = props.getDuplicateWOList, getServiceCodeWOType = props.getServiceCodeWOType, levelOneId = props.levelOneId, isAliasingView = props.isAliasingView, setDuplicateWOsLoading = props.setDuplicateWOsLoading, setHowToVideoVisible = props.setHowToVideoVisible, howToVideoVisible = props.howToVideoVisible, setSelectAlias = props.setSelectAlias, setAvailabilityParam = props.setAvailabilityParam;
    useEffect(function () {
        if (clientId) {
            getServiceComboAlias(ProblemLevel.LevelOne);
        }
        else {
            reGetClientId().then(function () {
                getServiceComboAlias(ProblemLevel.LevelOne);
            });
        }
    }, [clientId]);
    var getServiceComboAlias = function (problemLevel, parentId) {
        var param = {
            clientId: Cookies.get("clientId"),
            clientType: isIH() ? MobileDefinedClientType.IHResidential : MobileDefinedClientType.NonIHResidential,
            level: problemLevel,
            parentId: parentId ? parentId : null
        };
        getClientServiceComboAlias(param, problemLevel);
    };
    var problemLevels = [ProblemLevel.LevelOne, ProblemLevel.LevelTwo, ProblemLevel.LevelThree];
    var serviceCodeCheck = function (alias) {
        setAvailabilityParam("recallCertifierType", null);
        setAvailabilityParam("certifiedRecallWoId", null);
        Cookies.remove("residentResponsibilityCount");
        var setLastLevel = props.setLastLevel;
        setSelectAlias(alias);
        setLastLevel(isAliasingView ? alias.level : ProblemLevel.LevelThree);
        setDuplicateWOsLoading(true);
        residentResponsibilityCheck(alias);
    };
    var residentResponsibilityCheck = function (alias) {
        getServiceCodeWOType(alias).then(function (woType) {
            if (woType === PredefinedWoType.ResidentResponsibility) {
                Cookies.set("residentResponsibilityCount", "true");
                setDuplicateWOsLoading(false);
                setProblemLevel(ProblemLevel.ResidentResponsiBility);
            }
            else {
                Cookies.set("residentResponsibilityCount", "false");
                duplicateCheck(alias);
            }
        });
    };
    var duplicateCheck = function (alias) { return __awaiter(void 0, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getDuplicateWOs(alias)];
                case 1:
                    res = _a.sent();
                    if (!res.body || isEmpty(res.body)) {
                        recallCheck(alias);
                    }
                    else {
                        setProblemLevel(ProblemLevel.DuplicateCheck);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getDuplicateWOs = function (alias) { return __awaiter(void 0, void 0, void 0, function () {
        var setDuplicateWOsLoading, query, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setDuplicateWOsLoading = props.setDuplicateWOsLoading;
                    setDuplicateWOsLoading(true);
                    query = {
                        locationId: getLocationId(),
                        residentId: currentUser.residentId,
                        serviceCategoryId: isAliasingView ? alias.serviceCombo.serviceCategoryId : levelOneId
                    };
                    return [4 /*yield*/, getDuplicateWOList(query).finally(function () {
                            setDuplicateWOsLoading(false);
                        })];
                case 1:
                    res = _a.sent();
                    sendAmplitude_Default(AmplitudeEventName.RSPDuplicateWOs_Count, {
                        env: getCurrentEnv(),
                        userId: currentUser.userId,
                        residentId: currentUser.residentId,
                        locationId: getLocationId(),
                        clientId: clientId,
                        count: res.body ? res.body.length : 0,
                    });
                    return [2 /*return*/, res];
            }
        });
    }); };
    var recallCheck = function (alias) { return __awaiter(void 0, void 0, void 0, function () {
        var res;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, getRecallWOs(alias)];
                case 1:
                    res = _b.sent();
                    if (!res.body || isEmpty(res.body)) {
                        if ((_a = alias.serviceCombo) === null || _a === void 0 ? void 0 : _a.videoURL) {
                            handleVideoURL();
                        }
                        else {
                            jumpAction();
                        }
                    }
                    else {
                        setProblemLevel(ProblemLevel.RecallCheck);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var jumpAction = function () {
        var jump = props.jump;
        jump(StepType.Detail);
        setProblemLevel(DifferentIssue);
    };
    var getRecallWOs = function (alias) { return __awaiter(void 0, void 0, void 0, function () {
        var setDuplicateWOsLoading, getRecallWOList, levelThreeId, query, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setDuplicateWOsLoading = props.setDuplicateWOsLoading, getRecallWOList = props.getRecallWOList, levelThreeId = props.levelThreeId;
                    setDuplicateWOsLoading(true);
                    query = {
                        locationId: getLocationId(),
                        residentId: currentUser.residentId,
                        serviceCategoryId: isAliasingView ? alias === null || alias === void 0 ? void 0 : alias.serviceCombo.serviceCategoryId : levelOneId,
                        serviceCodeId: isAliasingView ? alias === null || alias === void 0 ? void 0 : alias.serviceCombo.serviceCodeId : levelThreeId
                    };
                    return [4 /*yield*/, getRecallWOList(query).finally(function () {
                            setDuplicateWOsLoading(false);
                        })];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, res];
            }
        });
    }); };
    var handleVideoURL = function () {
        if (isMobile) {
            setProblemLevel(ProblemLevel.HowToVideo);
        }
        else {
            setHowToVideoVisible(true);
        }
    };
    return React.createElement(React.Fragment, null,
        React.createElement(Loader, { page: true, visible: duplicateWOsLoading }),
        problemLevels.indexOf(level) > -1 && React.createElement("div", { className: 'dsm-card' },
            React.createElement("div", { className: 'dsm-card-body' },
                React.createElement("div", { className: 'py-2 px-20 problem' },
                    (level === ProblemLevel.LevelTwo || level === ProblemLevel.LevelThree) && React.createElement(ProblemAlias, null),
                    React.createElement(Loader, { visible: loading }),
                    level === ProblemLevel.LevelOne && !loading && React.createElement(LevelOne, { getServiceComboAlias: getServiceComboAlias }),
                    level === ProblemLevel.LevelTwo && !loading && React.createElement(LevelTwo, { getServiceComboAlias: getServiceComboAlias, serviceCodeCheck: serviceCodeCheck }),
                    level === ProblemLevel.LevelThree && !loading && React.createElement(LevelThree, { serviceCodeCheck: serviceCodeCheck })),
                levelOneAliasList.length > 0 && React.createElement(ICantFindMyIssue, null))),
        level === ProblemLevel.ResidentResponsiBility && React.createElement(ResidentResponsibility, { duplicateCheck: duplicateCheck }),
        level === ProblemLevel.DuplicateCheck && React.createElement(DuplicateCheckList, null),
        level === ProblemLevel.RecallCheck && React.createElement(RecallCheckList, null),
        (level !== ProblemLevel.DuplicateCheck && level !== ProblemLevel.RecallCheck && howToVideoVisible) && React.createElement(HowToVideo, { thenAction: jumpAction }),
        level === ProblemLevel.HowToVideo && React.createElement(HowToVideoMobile, { thenAction: jumpAction }));
}));
export default StepsProblem;
